import { CloudCog, Layers, Sparkles, Telescope } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
    {
        icon: CloudCog,
        title: "Foundational Strengths",
        body: "We specialize in Cloud, AI/ML, Big Data and System Integration with a proven track record across key industries, from BFSI to aviation.",
        big: true,
    },
    {
        icon: Layers,
        title: "Maturity Levels",
        body: "Our processes are standardized and our frameworks are scalable, ensuring consistent quality every step of the way.",
    },
    {
        icon: Sparkles,
        title: "Differentiator",
        body: "A dedicated AI Center of Excellence in Bengaluru drives innovation through research, prototyping and real-world application.",
    },
    {
        icon: Telescope,
        title: "Vision",
        body: "From tailored integrations to end-to-end support, we deliver reliable, enterprise-grade technology built for autonomous ecosystems.",
        big: true,
    },
];

export const Capabilities = () => (
    <section id="capabilities" data-testid="capabilities-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal className="max-w-2xl">
                <Eyebrow>What are we good at</Eyebrow>
                <h2 className="mb-4 font-syne text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="capabilities-heading">
                    Capability maturity describing what we are good at
                </h2>
                <p className="text-base text-slate-400 sm:text-lg">
                    Deep-rooted engineering discipline, refined across hundreds of enterprise programs.
                </p>
            </Reveal>

            <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {ITEMS.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.1} className={item.big ? "lg:col-span-2" : ""}>
                        <div
                            data-testid={`capability-card-${i}`}
                            className="card-glow-border group h-full rounded-2xl border border-white/[0.08] bg-card2/50 p-8"
                        >
                            <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-volt/20 bg-volt/10 text-volt transition-all duration-500 group-hover:scale-110 group-hover:shadow-[0_0_25px_rgba(0,240,255,0.3)]">
                                <item.icon size={22} />
                            </div>
                            <h3 className="mb-3 font-syne text-xl font-semibold text-slate-100">{item.title}</h3>
                            <p className="text-sm leading-relaxed text-slate-400 sm:text-base">{item.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
